/** Per-tab coordination identifier, never a credential and never persisted across tabs. */
export const instanceId = crypto.randomUUID();
export function instanceHeaders(): Record<string, string> {
  return { 'x-chefi-instance': instanceId };
}
export async function apiFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const address = new URL(
    input instanceof Request ? input.url : String(input),
    location.href,
  );
  if (
    address.origin !== location.origin ||
    !address.pathname.startsWith('/api/')
  )
    return globalThis.fetch(input, init);
  const headers = new Headers(
    init?.headers ?? (input instanceof Request ? input.headers : undefined),
  );
  headers.set('x-chefi-instance', instanceId);
  return globalThis.fetch(input, { ...init, headers });
}
